module.exports = __webpack_public_path__ + "static/media/logo-full.25e028b5.png";